export const MAX_FILE_UPLOAD_LIMIT_IN_BYTES = 2097152; // 2MB

export const ACCEPTED_FILE_UPLOAD_FORMATS =
  'application/pdf,image/jpg,image/jpeg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const ACCEPTED_FILE_UPLOAD_FORMATS_ARRAY = ACCEPTED_FILE_UPLOAD_FORMATS.split(',');
